// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import useValidateForm from '@Hooks/useValidateForm';
import THDrawer from '@Molecules/THDrawer/THDrawer';
import { LDAPServerType, ProfileOutput, OrganisationOutput } from 'thehive-sdk';
import { LdapServerForm, LdapServerFormOutput } from '@Organisms/Ldap/LdapServerForm/LdapServerForm';
import { useLocalMessage } from '@Helpers/locale';

interface LdapServerManageProps<I> {
    triggerElem: ReactElement;
    onFinish: (server: I) => Promise<void>;
    data?: I;
    namesList?: string[];
    profileList?: ProfileOutput[];
    organisationList?: OrganisationOutput[];
}

export const LdapServerManage = ({
    triggerElem,
    onFinish,
    data: defaultValues,
    namesList,
    profileList = [],
    organisationList = [],
}: LdapServerManageProps<LDAPServerType>): ReactElement => {
    const local = useLocalMessage();

    const { form, isValid, onFormValuesChange, fieldsTouched, setFieldsTouched } = useValidateForm();

    const onFinishHandler = (values: LdapServerFormOutput): Promise<void> => {
        return onFinish(values);
    };

    return (
        <THDrawer
            title={local('configPlateform.ldap.drawer.title')}
            triggerElem={triggerElem}
            className="drawer-form"
            disableClose={fieldsTouched}
            afterVisibleChange={() => {
                form.resetFields();
            }}
        >
            {(toggleDrawer) => (
                <LdapServerForm
                    form={form}
                    onFinish={(values) =>
                        onFinishHandler(values)
                            .then(() => {
                                toggleDrawer();
                                setFieldsTouched(false);
                            })
                            .catch((e) => e)
                    }
                    isValid={isValid && fieldsTouched}
                    onChange={() => {
                        onFormValuesChange();
                        setFieldsTouched(true);
                    }}
                    defaultValues={defaultValues}
                    onCancel={() => {
                        form.resetFields();
                        setFieldsTouched(false);
                        toggleDrawer();
                    }}
                    namesList={namesList}
                    profileList={profileList}
                    organisationList={organisationList}
                />
            )}
        </THDrawer>
    );
};
